<template>
    <Breadcrumbs main="Ecommerce" title="Payment Details" />
    <div class="container-fluid credit-card">
        <div class="row">
            <creditCard />
            <debitCard />
            <codCard />
            <emiCard />
            <netBanking />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const creditCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/creditCard.vue"))
const debitCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/debitCard.vue"))
const codCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/codCard.vue"))
const emiCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/emiCard.vue"))
const netBanking = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/netBanking.vue"))
</script>